import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class SeriesService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) {}

  addSeries(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.series.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allSeries(pagination?: { page?: number; limit?: number }) {
    const params: any = {};
    
    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }
    
    return this.httpService.makeRequest({
      path: this.routes.series.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editSeries(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.series.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteSeries(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.series.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.series.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSeriesBySpecialization(specializationId: number) {
    return this.httpService.makeRequest({
      path: this.routes.series.retrieve,
      method: 'get',
      options: { params: { specialization: specializationId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSeriesByDepartment(departmentId: number) {
    return this.httpService.makeRequest({
      path: this.routes.series.retrieve,
      method: 'get',
      options: { params: { department: departmentId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSeriesDetails(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.series.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
